


// This function is the main header shown at the top
export default function MyFooter() {
    return (
        <div className='myFooter_CSS'>
            <div className="copyright_Footer"> Copyright 2020 </div>
            <a className="legal_Link_Footer" href="./legal"> Legal and Privacy</a>
        </div>
    );
}
